import { Box, Checkbox, Chip, FormControl, InputLabel, ListItemText, MenuItem, Select } from "@mui/material";
import { observer } from "mobx-react-lite";
import { IRBDItem } from "../../app/models/rbd";
import { useStore } from "../../app/stores/store";
import { RBDTransmissionType } from "../../app/config/enum";

function RBDSettingTransmissionElement() {
    const { rbdStore } = useStore();

    const handleChange = (value: IRBDItem[]) => {
        rbdStore.setSelectedTransmissionItems(value);
    }

    return (
        <FormControl fullWidth sx={{ mb: 4 }}>
            <InputLabel id="elementLabel">Element</InputLabel>
            <Select
                labelId="elementLabel"
                disabled={rbdStore.isEdit || rbdStore.rbdItems.length === 0}
                value={rbdStore.selectedTransmissionItems}
                onChange={(e) => {
                    if (typeof e.target.value === "object")
                        handleChange(e.target.value);
                }}
                renderValue={(selected) =>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map((item) => (
                            <Chip key={item.sequence} label={item.name} />
                        ))}
                    </Box>
                }
                label="Element"
                multiple
            >
                {rbdStore.transmissionableItems().map((item, idx) => (
                    <MenuItem 
                        key={idx}
                        value={item as any}
                        disabled={
                            rbdStore.selectedTransmissionType === RBDTransmissionType.SHARING_LOAD &&
                            (rbdStore.selectedTransmissionItems.length >= 2) && 
                            !(rbdStore.selectedTransmissionItems.indexOf(item) >= 0)
                        }
                    >
                        <Checkbox checked={rbdStore.selectedTransmissionItems.indexOf(item) >= 0} />
                        <ListItemText primary={item.name + ". " + rbdStore.rbdItemRows.find(x => x.id === item.sequence)?.code ?? ""} />
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}

export default observer(RBDSettingTransmissionElement);